class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('.search-modal__close-button')?.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (this.querySelector('.search-modal--zaoud')) {
      document.body.classList.add('search-modal-open', 'overflow-hidden');
      document.dispatchEvent(new CustomEvent('zaoud:mega-nav:close'));
    } else {
      document.body.classList.add('overflow-hidden');
    }

    this.updateZaoudSearchPosition();
    this.onResize = this.onResize || (() => {
      if (this.isOpen()) this.updateZaoudSearchPosition();
    });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onResize, { passive: true });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch?.handleModalOpen) {
      predictiveSearch.handleModalOpen();
    } else if (predictiveSearch?.showDefaultCollection) {
      predictiveSearch.showDefaultCollection();
    }
  }

  updateZaoudSearchPosition() {
    if (!this.querySelector('.search-modal--zaoud')) return;

    const header = document.querySelector('.section-header') || document.querySelector('.header-wrapper');
    if (!header) return;

    const top = Math.max(0, Math.floor(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--zaoud-search-modal-top', `${top}px`);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'search-modal-open');
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onResize);
  }
}

customElements.define('details-modal', DetailsModal);
